import React from "react";
import { useFormikContext } from "formik";
import InputField from "../../forms/input-field";
import SelectField from "../../forms/select-field";
import ImageField from "../../forms/images-field";
import { GST_APPLIED, GST_NOT_APPLICABLE } from "./gst-applicable";

const StorePanGstTab = ({ disabled = false }) => {
  const { values, setFieldValue } = useFormikContext();
  return (
    <div className="w-full 2xl:w-[30%] lg:w-[60%] px-5 xl:px-10">
      <SelectField
        isDisabled={disabled}
        placeholder={"Select pan type"}
        options={panTypeList}
        label={"Select PAN Type"}
        id={"pan_type"}
        name="pan_type"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
        // isRequired={true}
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="pan_number"
        placeholder="Enter PAN Number"
        label="PAN Number"
        labelWidth="8.5rem"
      />
      <ImageField
        isDisabled={disabled}
        label="PAN Front"
        // isRequired={true}
        labelWidth="8.5rem"
        name="pan_pic_front"
      />
      <ImageField
        isDisabled={disabled}
        label="PAN Back "
        // isRequired={true}
        labelWidth="8.5rem"
        name="pan_pic_back"
        mainLabel=""
      />
      <SelectField
        isDisabled={disabled}
        placeholder={"Select"}
        options={gstApplicableList}
        label={"GST Applicable"}
        id={"gst_applicable"}
        name="gst_applicable"
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
        handleSelected={(selected) => {
          // Switching to Not Applicable clears the number and document, so a
          // store without GST cannot keep a stale certificate attached to it.
          if (selected?.value !== GST_APPLIED) {
            setFieldValue("gst_number", "");
            setFieldValue("gst_document", "");
          }
        }}
      />
      {values?.gst_applicable === GST_APPLIED && (
        <>
          <InputField
            isDisabled={disabled}
            type="text"
            name="gst_number"
            placeholder="Enter GST Number"
            label="GST Number"
            labelWidth="8.5rem"
          />
          <ImageField
            isDisabled={disabled}
            label="GST Document"
            labelWidth="8.5rem"
            name="gst_document"
            mainLabel=""
          />
        </>
      )}
    </div>
  );
};

export default StorePanGstTab;

const panTypeList = [{ label: "Buisness", value: "buisness" }];
const gstApplicableList = [
  { label: "Yes", value: GST_APPLIED },
  { label: "No", value: GST_NOT_APPLICABLE },
];